import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import { NotificationsLevel } from "../../../lib/enums";
import { ErrorResponse } from "../../../requests/@types";
import { route } from "../../../shim/jsbridge";
import { show } from "../../../notifications/notifications";
import api from "../api";
import { HTTP_TOO_MANY_REQUEST_STATUS_CODE } from "../consts";
import { sampleReportKeys } from "../queryKeys";

/**
 * Downloads screenshots in 7z format
 * @param hash samples hash value
 * @param analysisId analysisId for specific analysis
 * @param isNetwork fetch from network report
 * @return { downloadScreenshots }
 */
const useDownloadScreenshots = (
  hash: string,
  analysisId: string,
  isNetwork = false
) => {
  const downloadUrl = route(
    "api_rl_dynamic_analysis_resource_screenshots",
    [hash, analysisId],
    isNetwork ? { isNetwork } : {}
  );

  const { mutate } = useMutation<AxiosResponse<void>, ErrorResponse>({
    mutationKey: sampleReportKeys.downloadScreenshots(
      hash,
      analysisId,
      isNetwork
    ),
    mutationFn: () =>
      api.downloadRLSandboxScreenshots(hash, analysisId, isNetwork),
    onSuccess: () => {
      window.location = downloadUrl;
    },
    onError: responseError => {
      const errorMessage =
        responseError.status === HTTP_TOO_MANY_REQUEST_STATUS_CODE
          ? "Exceeding disk or memory usage, check system health status for more information."
          : "Unexpected error occurred while downloading screenshots.";

      show({
        level: NotificationsLevel.ERROR,
        message: errorMessage
      });
    }
  });

  const downloadScreenshots = () => {
    show({
      level: NotificationsLevel.SUCCESS,
      message: "Screenshot download has started..."
    });
    mutate();
  };

  return { downloadScreenshots };
};

export default useDownloadScreenshots;
